import { useMemo } from 'react'
import { IMediumPost } from '../../types'
import { cn } from '@/util/cn'
import Typography from '@/app/components/typography'

const LINK_COLOR_CLASS_NAMES = [
    'text-giphyPurple',
    'text-giphyIndigo',
    'text-giphyBlue',
    'text-giphyPink',
    'text-giphyYellow',
]

const getLinkColor = (index: number) => LINK_COLOR_CLASS_NAMES[index % LINK_COLOR_CLASS_NAMES.length]

type Props = {
    post: IMediumPost
    index: number
}

const AboutPageNewsPost = ({ post, index }: Props) => {
    const descriptionBits = useMemo(() => post.description.split('</p>'), [post.description])
    const descriptionText = useMemo(() => descriptionBits[0]?.replace(/(<([^>]+)>)/gi, '').trim(), [descriptionBits])

    return (
        <div className="relative mx-auto h-full w-[35rem] max-w-[75vw] bg-giphyBlack px-[2.1rem] pt-[9.625rem] pb-[4.125rem] text-left text-giphyWhite">
            <div
                className="absolute inset-0 h-[8.25rem] w-full bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${post.thumbnail})` }}
            />

            <Typography variant="text-xl" className="mt-1 mb-[0.7rem]" fontWeight="bold">
                {post.title}
            </Typography>

            {descriptionText && (
                <Typography as="p" variant="text-lg" className="pt-2 pb-[1.125rem] leading-[1.2]">
                    {descriptionText}
                </Typography>
            )}

            <a
                href={post.link}
                target="_blank"
                rel="noopener noreferrer"
                className={cn('absolute bottom-[2rem] left-[2rem]', getLinkColor(index))}
            >
                <Typography variant="text-lg" fontWeight="bold">
                    Keep Reading <i className="ss-navigateright ml-1 inline-block text-[0.75rem] text-giphyWhite" />
                </Typography>
            </a>
        </div>
    )
}

export default AboutPageNewsPost
